<div class="div-action-top">
    <form nz-form [nzLayout]="'inline'" [formGroup]="filterForm" class="form-filter" (ngSubmit)="doSearch()">
        <nz-form-item class="spacepad">
            <nz-form-control>
                <input nz-input formControlName="name" placeholder="Tên hóa chất" />
            </nz-form-control>
        </nz-form-item>
        <nz-form-item class="spacepad">
            <nz-form-control>
                <input nz-input formControlName="batchCode" placeholder="Mã hóa chất" />
            </nz-form-control>
        </nz-form-item>
        <nz-form-item class="spacepad">
            <nz-form-control>
                <input nz-input formControlName="amountMin" placeholder="Tồn kho tối thiểu" />
            </nz-form-control>
        </nz-form-item>
        <nz-form-item class="spacepad">
            <nz-form-control>
                <input nz-input formControlName="amountMax" placeholder="Tồn kho tối đa" />
            </nz-form-control>
        </nz-form-item>
        <nz-form-item class="spacepad">
            <nz-form-control>
                <nz-date-picker formControlName="expiredDateFrom" nzPlaceHolder="Từ ngày..." nzFormat="dd/MM/yyyy" nz-input placeholder="Từ  ngày">
                </nz-date-picker>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item class="spacepad">
            <nz-form-control>
                <nz-date-picker formControlName="expiredDateTo" nzPlaceHolder="Đến ngày..." nzFormat="dd/MM/yyyy" nz-input placeholder="Đến ngày">
                </nz-date-picker>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item class="spacepad">
            <nz-form-control>
                <button nz-button nzType="primary" [disabled]="!filterForm.valid">Tìm kiếm</button>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item class="spacepad">
            <nz-form-control>
                <button nz-button nzType="dashed" (click)="clearSearch()" [disabled]="!filterForm.valid">Bỏ lọc</button>
            </nz-form-control>
        </nz-form-item>
    </form>
</div>

<div class="data-table">
    <nz-table #basicTable [nzData]="datas" (nzCurrentPageDataChange)="currentPageDataChange($event)" [nzFrontPagination]="false"
        (nzQueryParams)="onQueryParamsChange($event)" [nzPageSizeOptions]="pageSize" [nzPageSize]="defaultPageSize"
        nzShowSizeChanger [nzTotal]="total" [nzShowTotal]="rangeTemplate"
        [nzLoading]="loading">
        <thead>
            <tr>
                <th nzWidth="60px">Action</th>
                <th class="text-nowrap" width="50px">#</th>
                <ng-container *ngFor="let col of this.dataColumnChecked">
                    <th class="text-nowrap">{{ col.label }}</th>
                </ng-container>
                <th class="text-nowrap" width="100px">Cảnh báo</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let data of datas; let i = index;">
                <tr>
                    <ng-container>
                        <td [nzExpand]="expandSet.has(data.chemicalId)" (nzExpandChange)="onExpandChange(data.chemicalId)"></td>
                        <td class="text-nowrap">{{getRowIndex(i, basicTable.nzPageIndex, basicTable.nzPageSize)}}</td>
                        <ng-container *ngFor="let col of this.dataColumnChecked">
                            <td *ngIf="col.name !== 'currentAmountByUnit' && col.name !== 'currentAmount'">{{ toTdValue(col.name, data) }}</td>
                          <td *ngIf="col.name === 'currentAmountByUnit' || col.name === 'currentAmount'">
                            {{ toTdValue(col.name, data)}}
                          </td>
                        </ng-container>
                        <td>
                            <img *ngIf="data.isWarning && data.isWarning.includes(CHEMICAL_WARNING_TYPE.expired)" src="/assets/image/warning-1.png"
                                width="18px" style="margin-right:5px;padding:0;" title="Hết hạn">
                            <img *ngIf="data.isWarning && data.isWarning.includes(CHEMICAL_WARNING_TYPE.almostExpired)" src="/assets/image/warning-2.png"
                                width="18px" style="margin-right:5px;padding:0;" title="Sắp hết hạn">
                            <img *ngIf="data.isWarning && data.isWarning.includes(CHEMICAL_WARNING_TYPE.amount)" src="/assets/image/warning-3.png"
                                width="18px" style="margin-right:5px;padding:0;" title="Tồn kho sắp hết">
                        </td>
                    </ng-container>
                </tr>
                <tr [nzExpand]="expandSet.has(data.chemicalId)">
                    <ul>
                      <li *ngFor="let item of data.batch" class="detail-item">
                        Hạn sử dụng:
                        <span *ngIf="datatimeToDateTimeZone(item.expiredDate, data.chemical.expiringDayAlert, data) === 1" style="color:red;">{{item.expiredDate| date: "dd-MM-yyyy"}}</span>
                        <span *ngIf="datatimeToDateTimeZone(item.expiredDate, data.chemical.expiringDayAlert, data)===0">{{item.expiredDate| date: "dd-MM-yyyy"}}</span>
                        <span *ngIf="datatimeToDateTimeZone(item.expiredDate, data.chemical.expiringDayAlert, data)===2" class="css-currentAmount">{{item.expiredDate| date: "dd-MM-yyyy"}}</span>

                        Mã lô:
                        <strong>{{item.batchCode}}</strong>
                        <span></span> -
                        Số lượng:
                        <strong *ngIf="checkAmount(item, data) == 0"
                              style="color: orange ;">{{item.currentAmount }} {{item.unitTypeText}}</strong>
                        <strong *ngIf="checkAmount(item, data) == 1">{{item.currentAmount }} {{item.unitTypeText}}</strong>
                        <strong *ngIf="checkAmount(item, data) == 2">{{item.currentAmount }} {{item.unitTypeText}}</strong>
                        <span></span>

                      </li>
                    </ul>
                </tr>

            </ng-container>

        </tbody>
    </nz-table>
    <ng-template #rangeTemplate let-range="range" let-total>
        {{ range[0] }}-{{ range[1] }} {{'of' | translate }} {{ total }} {{'items' | translate }}
    </ng-template>
</div>
